import { render, staticRenderFns } from "./ServerExp.vue?vue&type=template&id=740ba168&scoped=true"
var script = {}
import style0 from "./ServerExp.vue?vue&type=style&index=0&id=740ba168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ba168",
  null
  
)

export default component.exports